import { axios } from "@/lib/axios";

export function apiGetTopicTree() {
    return axios.post( "/api/front/topic/tree" );
}
